import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-common-strings';
import { FindRecipientInfoType } from 'owa-recipient-common/lib/components/FindRecipientInfo';
import * as React from 'react';
var styles = require('./SuggestionsHeaderFooterInfo.scss');
var classNames = require('classnames/bind').bind(styles);
var SuggestionsHeaderFooterInfo = function (props) {
    switch (props.infoType) {
        case FindRecipientInfoType.SuggestedContacts:
            return (React.createElement("div", { className: classNames(styles.textContainer, styles.suggestedContactsHeaderBox) },
                React.createElement("span", { className: styles.suggestedContactsText }, strings.findRecipientResult_SuggestedContactsHeader)));
        case FindRecipientInfoType.Searching:
            return (React.createElement("div", { className: classNames(styles.footerBorder, styles.container) },
                React.createElement("div", { className: styles.iconContainer },
                    React.createElement(Spinner, { className: styles.loadingSpinner })),
                React.createElement("div", { className: styles.textContainer }, format(strings.findRecipientInfo_Searching, props.queryString))));
        case FindRecipientInfoType.TypeToSearch:
            return (React.createElement("div", { className: styles.container },
                React.createElement("div", { className: classNames(styles.textContainer, styles.centered) }, strings.findRecipientInfo_TypeToSearch)));
        case FindRecipientInfoType.SearchDirectory:
            return (React.createElement("div", { className: classNames(styles.footerBorder, styles.container) },
                React.createElement("div", { className: styles.iconContainer },
                    React.createElement(Icon, { className: styles.searchIcon, iconName: "Search" /* Search */ })),
                React.createElement("div", { className: styles.textContainer }, isConsumer()
                    ? strings.findRecipientInfo_SearchPeople
                    : strings.findRecipientInfo_SearchDirectory)));
        case FindRecipientInfoType.TopNResults:
            return (React.createElement("div", { className: classNames(styles.footerBorder, styles.container) },
                React.createElement("div", { className: classNames(styles.textContainer, styles.centered) }, props.numberOfResults
                    ? format(strings.findRecipientInfo_TopNResults, props.numberOfResults)
                    : strings.findRecipientInfo_NoResultsFound)));
        case FindRecipientInfoType.UseAddress:
            return (React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("div", { className: classNames(styles.headerBorder, styles.textContainer, styles.useAddressContainer) }, format(strings.findRecipientInfo_UseThisAddress, props.queryString)))));
        default:
            return null;
    }
};
export default SuggestionsHeaderFooterInfo;
//# sourceMappingURL=SuggestionsHeaderFooterInfo.js.map